//
//    WARNING
//    This file was auto-generated by swagger-typescript-codegen.
//    Please do not make changes here because they may be overwritten.
//

import request from 'superagent';
import { SuperAgentStatic, SuperAgentRequest, Response } from 'superagent';
import {
  CallbackHandler,
  RequestHeadersHandler,
  ConfigureAgentHandler,
  ConfigureRequestHandler,
  Logger,
  RequestHeaders,
  QueryParameters,
  CommonRequestOptions,
  ResponseWithBody,
  ProblemDetails,
} from './types';

export type GetTestExecutionDto = {
  clientId?: string;
  completedCount?: number;
  failedCount?: number;
  id?: string;
  isCompleted?: boolean;
  isSuccessful?: boolean;
  modelId?: string;
  modelVersion?: string;
  successfulCount?: number;
  testCaseResults?: Array<TestResult>;
  totalCount?: number;
};

export type IContractResolver = {};

export type ITestCaseJsonPatchDocument = {
  contractResolver?: IContractResolver;
  operations?: Array<ITestCaseOperation>;
};

export type ITestCaseOperation = {
  from?: string;
  op?: string;
  operationType?: OperationType;
  path?: string;
  value?: unknown;
};

export type OperationType = 0 | 1 | 2 | 3 | 4 | 5 | 6;

export type PatchTestCaseDto = {
  description?: string;
  expectedOutput?: { [key: string]: unknown };
  targetModelId?: string;
  targetModelVersion?: number;
  testData?: { [key: string]: unknown };
};

export type PostTestCaseDto = {
  description: string;
  expectedOutput: { [key: string]: unknown };
  targetModelId: string;
  targetModelVersion: number;
  testData: { [key: string]: unknown };
};

export type TestCase = {
  clientId?: string;
  description?: string;
  expectedOutput?: {};
  id?: string;
  partitionKey?: string;
  targetModelId?: string;
  targetModelVersion?: number;
  testData?: { [key: string]: unknown };
};

export type TestCaseEntity = {
  clientId: string;
  description: string;
  expectedOutput: { [key: string]: unknown };
  id: string;
  partitionKey: string;
  targetModelId: string;
  targetModelVersion: number;
  testData: { [key: string]: unknown };
};

export type TestFailure = {
  actualValue?: unknown;
  expectedValue?: unknown;
  propertyName?: string;
};

export type TestResult = {
  calculationId?: string;
  clientId?: string;
  failures?: Array<TestFailure>;
  id?: string;
  isSuccessful?: boolean;
  targetModelId?: string;
  targetModelVersion?: number;
  testCaseId?: string;
  testExecutionId?: string;
};

export type Response_getClientsByClientIdTestCases_200 = Array<TestCaseEntity>;

/**
 * Insight2Profit test case service
 * @class TestCaseService
 * @param {(string)} [domainOrOptions] - The project domain.
 */
export class TestCaseService {
  private domain: string = '';
  private errorHandlers: CallbackHandler[] = [];
  private requestHeadersHandler?: RequestHeadersHandler;
  private configureAgentHandler?: ConfigureAgentHandler;
  private configureRequestHandler?: ConfigureRequestHandler;

  constructor(domain?: string, private logger?: Logger) {
    if (domain) {
      this.domain = domain;
    }
  }

  getDomain() {
    return this.domain;
  }

  addErrorHandler(handler: CallbackHandler) {
    this.errorHandlers.push(handler);
  }

  setRequestHeadersHandler(handler: RequestHeadersHandler) {
    this.requestHeadersHandler = handler;
  }

  setConfigureAgentHandler(handler: ConfigureAgentHandler) {
    this.configureAgentHandler = handler;
  }

  setConfigureRequestHandler(handler: ConfigureRequestHandler) {
    this.configureRequestHandler = handler;
  }

  private request(
    method: string,
    url: string,
    body: any,
    headers: RequestHeaders,
    queryParameters: QueryParameters,
    form: any,
    reject: CallbackHandler,
    resolve: CallbackHandler,
    opts: CommonRequestOptions
  ) {
    if (this.logger) {
      this.logger.log(`Call ${method} ${url}`);
    }

    const agent = this.configureAgentHandler ? this.configureAgentHandler(request) : request;

    let req = agent(method, url);
    if (this.configureRequestHandler) {
      req = this.configureRequestHandler(req);
    }

    req = req.query(queryParameters);

    if (body) {
      req.send(body);

      if (typeof body === 'object' && !(body.constructor.name === 'Buffer')) {
        headers['Content-Type'] = 'application/json';
      }
    }

    headers['x-insight-ns'] = 'master';

    if (Object.keys(form).length > 0) {
      req.type('form');
      req.send(form);
    }

    if (this.requestHeadersHandler) {
      headers = this.requestHeadersHandler({
        ...headers,
      });
    }

    req.set(headers);

    if (opts.$retries && opts.$retries > 0) {
      req.retry(opts.$retries);
    }

    if ((opts.$timeout && opts.$timeout > 0) || (opts.$deadline && opts.$deadline > 0)) {
      req.timeout({
        deadline: opts.$deadline,
        response: opts.$timeout,
      });
    }

    // req = req.withCredentials();

    req.end((error, response) => {
      // an error will also be emitted for a 4xx and 5xx status code
      // the error object will then have error.status and error.response fields
      // see superagent error handling: https://github.com/visionmedia/superagent/blob/master/docs/index.md#error-handling
      if (error) {
        reject(error);
        this.errorHandlers.forEach((handler) => handler(error));
      } else {
        resolve(response);
      }
    });
  }

  /**
   *
   * @method
   * @name TestCaseService#postClientsByClientIdTestCase
   * @description /testcase/clients/{clientId}/test-case
   * @param {string} clientId - Insight2Profit test case service
   * @param {} body - Insight2Profit test case service
   */
  postClientsByClientIdTestCase(
    parameters: {
      clientId: string;
      body?: PostTestCaseDto;
    } & CommonRequestOptions
  ): Promise<
    ResponseWithBody<201, TestCase> | ResponseWithBody<404, ProblemDetails> | ResponseWithBody<number, ProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = 'testcase/clients/{clientId}/test-case';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'text/plain, application/json, text/json';
      headers['content-type'] = 'application/json-patch+json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      form = queryParameters;
      queryParameters = {};

      this.request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name TestCaseService#getClientsByClientIdTestCases
   * @description /testcase/clients/{clientId}/test-cases
   * @param {string} clientId - Insight2Profit test case service
   * @param {string} continuationToken - Insight2Profit test case service
   */
  getClientsByClientIdTestCases(
    parameters: {
      clientId: string;
      continuationToken?: string;
    } & CommonRequestOptions
  ): Promise<ResponseWithBody<200, Response_getClientsByClientIdTestCases_200>> {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/testcase/clients/{clientId}/test-cases';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'text/plain, application/json, text/json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      if (parameters['continuationToken'] !== undefined) {
        queryParameters['continuationToken'] = parameters['continuationToken'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name TestCaseService#postClientsByClientIdTestCases
   * @description /testcase/clients/{clientId}/test-cases
   * @param {string} clientId - Insight2Profit test case service
   * @param {} body - Insight2Profit test case service
   */
  postClientsByClientIdTestCases(
    parameters: {
      clientId: string;
      body?: Array<PostTestCaseDto>;
    } & CommonRequestOptions
  ): Promise<
    ResponseWithBody<200, void> | ResponseWithBody<404, ProblemDetails> | ResponseWithBody<number, ProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/testcase/clients/{clientId}/test-cases';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'text/plain, application/json, text/json';
      headers['content-type'] = 'application/json-patch+json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      form = queryParameters;
      queryParameters = {};

      this.request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name TestCaseService#deleteClientsByClientIdTestCasesById
   * @description /testcase/clients/{clientId}/test-cases/{id}
   * @param {string} clientId - Insight2Profit test case service
   * @param {string} id - Insight2Profit test case service
   */
  deleteClientsByClientIdTestCasesById(
    parameters: {
      clientId: string;
      id: string;
    } & CommonRequestOptions
  ): Promise<ResponseWithBody<200, TestCase> | ResponseWithBody<404, ProblemDetails>> {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/testcase/clients/{clientId}/test-cases/{id}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'text/plain, application/json, text/json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      path = path.replace('{id}', `${parameters['id']}`);

      if (parameters['id'] === undefined) {
        reject(new Error('Missing required  parameter: id'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('DELETE', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name TestCaseService#getClientsByClientIdTestCasesById
   * @description /testcase/clients/{clientId}/test-cases/{id}
   * @param {string} clientId - Insight2Profit test case service
   * @param {string} id - Insight2Profit test case service
   */
  getClientsByClientIdTestCasesById(
    parameters: {
      clientId: string;
      id: string;
    } & CommonRequestOptions
  ): Promise<ResponseWithBody<200, void> | ResponseWithBody<404, ProblemDetails>> {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/testcase/clients/{clientId}/test-cases/{id}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'text/plain, application/json, text/json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      path = path.replace('{id}', `${parameters['id']}`);

      if (parameters['id'] === undefined) {
        reject(new Error('Missing required  parameter: id'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name TestCaseService#patchClientsByClientIdTestCasesById
   * @description /testcase/clients/{clientId}/test-cases/{id}
   * @param {string} id - Insight2Profit test case service
   * @param {string} clientId - Insight2Profit test case service
   * @param {} body - Insight2Profit test case service
   */
  patchClientsByClientIdTestCasesById(
    parameters: {
      id: string;
      clientId: string;
      body?: PatchTestCaseDto;
    } & CommonRequestOptions
  ): Promise<
    ResponseWithBody<200, TestCase> | ResponseWithBody<400, ProblemDetails> | ResponseWithBody<404, ProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/testcase/clients/{clientId}/test-cases/{id}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'text/plain, application/json, text/json';
      headers['content-type'] = 'application/json';

      path = path.replace('{id}', `${parameters['id']}`);

      if (parameters['id'] === undefined) {
        reject(new Error('Missing required  parameter: id'));
        return;
      }

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('PATCH', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name TestCaseService#putClientsByClientIdTestCasesById
   * @description /testcase/clients/{clientId}/test-cases/{id}
   * @param {string} clientId - Insight2Profit test case service
   * @param {string} id - Insight2Profit test case service
   * @param {} body - Insight2Profit test case service
   */
  putClientsByClientIdTestCasesById(
    parameters: {
      clientId: string;
      id: string;
      body?: PostTestCaseDto;
    } & CommonRequestOptions
  ): Promise<ResponseWithBody<200, TestCase> | ResponseWithBody<404, ProblemDetails>> {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/testcase/clients/{clientId}/test-cases/{id}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'text/plain, application/json, text/json';
      headers['content-type'] = 'application/json-patch+json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      path = path.replace('{id}', `${parameters['id']}`);

      if (parameters['id'] === undefined) {
        reject(new Error('Missing required  parameter: id'));
        return;
      }

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('PUT', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name TestCaseService#patchClientsByClientIdTestCasesByIdPatch
   * @description /testcase/clients/{clientId}/test-cases/{id}/patch
   * @param {string} id - Insight2Profit test case service
   * @param {string} clientId - Insight2Profit test case service
   * @param {} body - Insight2Profit test case service
   */
  patchClientsByClientIdTestCasesByIdPatch(
    parameters: {
      id: string;
      clientId: string;
      body?: ITestCaseJsonPatchDocument;
    } & CommonRequestOptions
  ): Promise<
    ResponseWithBody<200, TestCase> | ResponseWithBody<400, ProblemDetails> | ResponseWithBody<404, ProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/testcase/clients/{clientId}/test-cases/{id}/patch';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'text/plain, application/json, text/json';
      headers['content-type'] = 'application/json-patch+json';

      path = path.replace('{id}', `${parameters['id']}`);

      if (parameters['id'] === undefined) {
        reject(new Error('Missing required  parameter: id'));
        return;
      }

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('PATCH', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name TestCaseService#getClientsByClientIdTestCasesByTestCaseIdResults
   * @description /testcase/clients/{clientId}/test-cases/{testCaseId}/results
   * @param {string} clientId - Insight2Profit test case service
   * @param {string} testCaseId - Insight2Profit test case service
   */
  getClientsByClientIdTestCasesByTestCaseIdResults(
    parameters: {
      clientId: string;
      testCaseId: string;
    } & CommonRequestOptions
  ): Promise<ResponseWithBody<200, GetTestExecutionDto>> {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/testcase/clients/{clientId}/test-cases/{testCaseId}/results';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'text/plain, application/json, text/json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      path = path.replace('{testCaseId}', `${parameters['testCaseId']}`);

      if (parameters['testCaseId'] === undefined) {
        reject(new Error('Missing required  parameter: testCaseId'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name TestCaseService#getClientsByClientIdTestExecutionsById
   * @description /testcase/clients/{clientId}/test-executions/{id}
   * @param {string} clientId - Insight2Profit test case service
   * @param {string} id - Insight2Profit test case service
   */
  getClientsByClientIdTestExecutionsById(
    parameters: {
      clientId: string;
      id: string;
    } & CommonRequestOptions
  ): Promise<ResponseWithBody<200, void> | ResponseWithBody<404, ProblemDetails>> {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/testcase/clients/{clientId}/test-executions/{id}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'text/plain, application/json, text/json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      path = path.replace('{id}', `${parameters['id']}`);

      if (parameters['id'] === undefined) {
        reject(new Error('Missing required  parameter: id'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name TestCaseService#getClientsByClientIdTestExecutionsByTestCaseIdResults
   * @description /testcase/clients/{clientId}/test-executions/{testCaseId}/results
   * @param {string} clientId - Insight2Profit test case service
   * @param {string} testCaseId - Insight2Profit test case service
   */
  getClientsByClientIdTestExecutionsByTestCaseIdResults(
    parameters: {
      clientId: string;
      testCaseId: string;
    } & CommonRequestOptions
  ): Promise<ResponseWithBody<200, GetTestExecutionDto>> {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/testcase/clients/{clientId}/test-executions/{testCaseId}/results';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'text/plain, application/json, text/json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      path = path.replace('{testCaseId}', `${parameters['testCaseId']}`);

      if (parameters['testCaseId'] === undefined) {
        reject(new Error('Missing required  parameter: testCaseId'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }
}

export default TestCaseService;
